import { z } from 'zod';

import type { StaffSession, StaffUser } from '../model/types';

/** Validated at the boundary, mapped straight to the entity type (§7.4). */
const staffUserDto = z.object({
  id: z.string().min(1),
  name: z.string(),
  title: z.string().nullable(),
  email: z.string(),
  roles: z.array(z.string()),
  permissions: z.array(z.string()),
});

export const staffUserSchema = staffUserDto;

export const staffLoginSchema = z.object({
  token: z.string().min(1),
  expiresAt: z.string().datetime({ offset: true }),
  user: staffUserDto,
});

export const staffLogoutSchema = z.object({ revoked: z.boolean() });

export function toStaffUser(dto: z.infer<typeof staffUserDto>): StaffUser {
  return {
    id: dto.id,
    name: dto.name,
    title: dto.title,
    email: dto.email,
    roles: dto.roles,
    permissions: dto.permissions,
  };
}

export function toStaffSession(dto: z.infer<typeof staffLoginSchema>): StaffSession {
  return {
    token: dto.token,
    expiresAt: new Date(dto.expiresAt),
    user: toStaffUser(dto.user),
  };
}
